import { groupBy, orderBy } from "lodash";

import {
  AssetClass,
  AssetClassCategory,
  AssetClassId,
} from "@fartherfinance/frontend/api/Investment/types";

import { AssetCategoryWithClasses } from "../reducer/Types";

import getAssetClassCategoryLabelFromEnum from "./getAssetClassCategoryLabelFromEnum";

// converts default asset classes coming from BE to the format that the asset classes dropdown component expects
const transformGetAssetClassesData = (
  assetClassesAndTheirCategories: AssetClass[]
): AssetCategoryWithClasses[] => {
  const groupedByCategory = groupBy(
    assetClassesAndTheirCategories,
    (ac) => ac.assetClassCategory
  );

  return orderBy(
    Object.entries(groupedByCategory).map(([cat, assetClasses]) => ({
      category: getAssetClassCategoryLabelFromEnum(
        AssetClassCategory.parse(cat)
      ),
      options: orderBy(assetClasses, [(ac) => ac.assetClassName], ["asc"]).map(
        (ac) => ({
          id: AssetClassId.parse(ac.assetClassId),
          label: ac.assetClassName,
          label2: ac.ownerId !== null ? "(Custom)" : "",
        })
      ),
    })),
    [(cat) => cat.category],
    ["asc"]
  );
};

export default transformGetAssetClassesData;
